<template>
  <svg
    id="animated-logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 469.7 469.7"
    :class="className"
  >
    <g>
      <rect class="logo-cls-1" x="309" y="142.4" width="20.3" height="184.9" />
      <rect class="logo-cls-1" x="224.7" y="31.8" width="20.3" height="406.2" />
      <rect class="logo-cls-1" x="337.1" y="98.2" width="20.3" height="273.3" />
      <rect class="logo-cls-1" x="280.9" y="101.5" width="20.3" height="266.8" />
      <rect class="logo-cls-2" x="365.2" y="47.2" width="20.3" height="375.3" />
      <rect class="logo-cls-1" x="449.4" y="181.7" width="20.3" height="106.3" />
      <rect class="logo-cls-1" x="421.3" y="146.5" width="20.3" height="176.8" />
      <rect class="logo-cls-1" x="393.2" y="169.9" width="20.3" height="130" />
      <rect class="logo-cls-1" x="252.8" y="0" width="20.3" height="469.7" />
      <rect class="logo-cls-1" x="28.1" y="125.8" width="20.3" height="218.1" />
      <rect class="logo-cls-1" x="196.6" y="71" width="20.3" height="327.8" />
      <rect class="logo-cls-1" x="56.2" y="158.8" width="20.3" height="152.2" />
      <rect class="logo-cls-1" x="0" y="180.1" width="20.3" height="109.5" />
      <rect class="logo-cls-1" x="84.3" y="81.8" width="20.3" height="306.3" />
      <rect class="logo-cls-2" x="112.4" y="137.6" width="20.3" height="194.6" />
      <rect class="logo-cls-1" x="168.6" y="0" width="20.3" height="469.7" />
      <rect class="logo-cls-1" x="140.5" y="45.9" width="20.3" height="378" />
    </g>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  className?: string
}>()
</script>

<style scoped>
.logo-cls-1 {
  fill: #003c71;
}
.logo-cls-2 {
  fill: #e57200;
}

/* Wavy animation for each rect */
#animated-logo rect {
  animation: wave 3s ease-in-out infinite;
  transform-origin: center bottom;
}

/* Stagger the animation delays for wavy effect */
#animated-logo rect:nth-child(1) {
  animation-delay: 0s;
}
#animated-logo rect:nth-child(2) {
  animation-delay: 0.1s;
}
#animated-logo rect:nth-child(3) {
  animation-delay: 0.2s;
}
#animated-logo rect:nth-child(4) {
  animation-delay: 0.3s;
}
#animated-logo rect:nth-child(5) {
  animation-delay: 0.4s;
}
#animated-logo rect:nth-child(6) {
  animation-delay: 0.5s;
}
#animated-logo rect:nth-child(7) {
  animation-delay: 0.6s;
}
#animated-logo rect:nth-child(8) {
  animation-delay: 0.7s;
}
#animated-logo rect:nth-child(9) {
  animation-delay: 0.8s;
}
#animated-logo rect:nth-child(10) {
  animation-delay: 0.9s;
}
#animated-logo rect:nth-child(11) {
  animation-delay: 1s;
}
#animated-logo rect:nth-child(12) {
  animation-delay: 1.1s;
}
#animated-logo rect:nth-child(13) {
  animation-delay: 1.2s;
}
#animated-logo rect:nth-child(14) {
  animation-delay: 1.3s;
}
#animated-logo rect:nth-child(15) {
  animation-delay: 1.4s;
}
#animated-logo rect:nth-child(16) {
  animation-delay: 1.5s;
}
#animated-logo rect:nth-child(17) {
  animation-delay: 1.6s;
}

@keyframes wave {
  0%,
  100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(1.15);
  }
}
</style>
